import { createPortal } from 'react-dom';
import { ArrowLeft, NoticeFill } from '@peacecover/icon';
import type { PayLetterPaymentMethod } from '../../../domains/orders/services/orderServices';
import { PAY_LETTER_PAYMENT_METHOD_OPTIONS } from '../constants/payLetterPaymentMethods';

interface PayLetterPaymentMethodSelectorProps {
  isOpen: boolean;
  isSubmitting?: boolean;
  onClose: () => void;
  onSelect: (paymentMethod: PayLetterPaymentMethod) => void;
}

const PayLetterPaymentMethodSelector = ({
  isOpen,
  isSubmitting = false,
  onClose,
  onSelect
}: PayLetterPaymentMethodSelectorProps) => {
  if (!isOpen) return null;
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[20000] bg-background-light dark:bg-background-dark pointer-events-auto">
      <div className="px-[16px] py-[10px] flex items-center">
        <button type="button" onClick={onClose}>
          <ArrowLeft className="text-text-main-lv1" />
        </button>
      </div>
      <div className="flex flex-col items-center gap-[14px] px-[24px] py-[10px] mt-[78px]">
        <p className="text-[26px] font-bold text-text-main-lv1">결제수단 선택</p>
        <p className="text-[15px] leading-[18px] text-text-main-lv4">
          원하는 결제 서비스를 선택하세요
        </p>
      </div>

      <div className="flex items-center gap-[7px] pl-[10px] pt-[9px] pb-[10px] w-full rounded-[12px] bg-separator1 shadow-[0_0_2px_0_rgba(0,0,0,0.05),0_0_8px_0_rgba(0,0,0,0.05)]">
        <NoticeFill size={13} className="text-text-main-lv4" />
        <span>BC카드는 지금 이용할 수 없어요</span>
      </div>
      <div className="grid grid-cols-2 gap-[10px]">
        {PAY_LETTER_PAYMENT_METHOD_OPTIONS.map((method) => (
          <button
            key={method.value}
            type="button"
            className={`w-full min-h-[78px] rounded-[16px] border text-left px-[14px] py-[12px] shadow-[0_1px_4px_rgba(0,0,0,0.06)] transition-transform active:scale-[0.98] disabled:opacity-60 disabled:active:scale-100 ${method.buttonClassName}`}
            disabled={isSubmitting}
            onClick={() => onSelect(method.value)}
          >
            <div className="flex flex-col gap-[8px]">
              <span
                className={`inline-flex w-fit items-center rounded-full px-[8px] py-[3px] text-[10px] font-semibold tracking-[0.02em] ${method.badgeClassName}`}
              >
                {method.subLabel}
              </span>
              <span className="text-[14px] font-semibold leading-[18px]">{method.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>,
    document.body
  );
};

export default PayLetterPaymentMethodSelector;
